/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import classNames from 'classnames';
import './ShiftPreset.scss';
import { cloneElement } from 'react';
import Col from 'react-bootstrap/Col';
import { ProviderRateTypeEnum } from '../../../../api';
import { IShiftPreset, Shift } from './ShiftPreset.model';

export type IndividualShiftPresetsPropsType = {
  colSize: number;
  presets: IShiftPreset[];
  onApplyPreset: (preset: IShiftPreset, shift: Shift) => void;
  shiftField: Shift;
  currentType: ProviderRateTypeEnum;
};

export const IndividualShiftPresets = ({
  colSize,
  presets,
  onApplyPreset,
  shiftField,
  currentType,
}: IndividualShiftPresetsPropsType) => {
  return (
    <div className="preset-short-list">
      {presets.map((preset, index) => {
        const { icon } = preset;
        const active = currentType === preset.type;

        const handleClick = (preset: IShiftPreset) => {
          if (preset.active) {
            return;
          }
          onApplyPreset(preset, shiftField);
        };

        return (
          <Col xs={colSize} key={`${index}-${shiftField.key}`} className="preset short">
            <div
              className={classNames('preset-short-list item', {
                ['cursor-pointer']: !active,
                ['item-active']: active,
                ['border-right-radius']: index === presets?.length - 1,
                ['border-left-radius']: index === 0,
              })}
              onClick={() => handleClick(preset)}
            >
              {cloneElement(icon, {
                className: classNames('preset-icon', { ['icon-active']: active }),
              })}
            </div>
          </Col>
        );
      })}
    </div>
  );
};
